import { useState } from "react"
import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"
import { SettingsTabs } from "../components/ui/school/school-settings/settings-tab"

const SchoolSettingsPage = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true)

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* School Sidebar */}
      <SchoolSidebar />

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 p-4 md:p-6 lg:p-8 overflow-y-auto">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">Settings</h1>
            <p className="text-gray-600 mt-2">Manage your account settings and preferences</p>
          </div>

          {/* Settings Content */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-200">
            <SettingsTabs />
          </div>
        </div>
      </main>
    </div>
  )
}

export default SchoolSettingsPage